import React, { useCallback, useState } from "react";
import { Modal } from "@sia/style-guide";

const defaultModalCopy = {
  titleKey: "benchmarking.survey.save-form-warning-modal.title",
  leadKey: "benchmarking.survey.save-form-warning-modal.lead",
  cancelLabelKey: "modal.button.cancel",
  confirmLabelKey: "modal.button.discard-changes",
};

export function useUnsavedChangesGuard({ translate }) {
  const [pendingAction, setPendingAction] = useState(null);

  const requestGuardedAction = useCallback(({ reason, isDirty, onDiscard, onContinue, onCleanContinue, onCancel, modalCopy = defaultModalCopy }) => {
    if (!isDirty) {
      const cleanAction = onCleanContinue || onContinue;
      if (cleanAction) cleanAction();
      return;
    }
    setPendingAction({
      reason,
      onDiscard,
      onContinue,
      onCancel,
      modalCopy: {
        ...defaultModalCopy,
        ...modalCopy,
      },
    });
  }, []);

  const cancelDiscard = useCallback(() => {
    const action = pendingAction;

    setPendingAction(null);
    if (action?.onCancel) action.onCancel();
  }, [pendingAction]);

  const confirmDiscard = useCallback(async () => {
    const action = pendingAction;
    if (!action) return;
    setPendingAction(null);
    if (action.onDiscard) await action.onDiscard();
    if (action.onContinue) await action.onContinue();
  }, [pendingAction]);

  const DiscardChangesModal = () => {
    return (
      pendingAction && (
        <Modal
          title={translate(pendingAction.modalCopy.titleKey)}
          lead={translate(pendingAction.modalCopy.leadKey)}
          cancelLabel={translate(pendingAction.modalCopy.cancelLabelKey)}
          onCancel={cancelDiscard}
          confirmLabel={translate(pendingAction.modalCopy.confirmLabelKey)}
          onConfirm={confirmDiscard}
        />
      )
    );
  };

  return {
    requestGuardedAction,
    DiscardChangesModal,
    isDiscardConfirmationShown: Boolean(pendingAction),
  };
}
